(function($) {
  let FrontendApi = false;
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', init);  
  
  async function init() {    
  	// addSocialSharebuttons();
    addAdvancedDescription();
    saveBuild.init();
    FrontendApi = await activateFrontendAPI();
    randomizer.init();
    // customAddToCart();
    replaceDownpayOption();
  }

  function customAddToCart() {
      if (!!window._cpb.settings === false) window._cpb.settings = {}
      window._cpb.settings.addToCartOverride = async data => {
        const customItems = data.items.map(item => {
          return { ...item, selling_plan: window.downpay.selected_selling_plan_id };
        });
        fetch("/cart/add.js", {
            "headers": {
                "content-type": "application/json;charset=UTF-8"
            },
            "body": JSON.stringify({
                items: customItems
            }),
            "method": "POST"
        }).then(() => {
            if(data.redirect) location.href = '/cart'
        })
      }
    }
  
  function replaceDownpayOption() {
    const downpay = document.querySelector('#downpay-block')
    const agreement = document.querySelector('.cpb-agreement-wrapper')

    downpay.style.margin = '10px 0px'

    agreement?.after(downpay)
  }
  
  function addAdvancedDescription() {
  	const description = $('#advanced-product-description');
//     $('.cpb-panels-container .cpb-product-actions').prepend(description.css('display', ''));
    $('.cpb-panels-container .cpb-panels-tabs-wrapper').prepend(description.css('display', ''));
  }
  
  const randomizer = {
    product: false,
    init() {
      this.product = CPB.getStore().getState().Product;
      this.addButton();
    },
    addButton() {
      const btn = $('<button class="cpb-actions-btn cpb-custom-actions-btn cpb-custom-random">').append($('<span>').text('Surprise Me!'));
      const addToCart = $('.cpb-add-to-cart-button');
      btn.on('click', this.randomize.bind(this));
      addToCart.parent().append(btn);
    },
    async randomize() {
      let timeout = 0;
      for(let i = 0; i < this.product.panels.length; i++) {
      	let panel = this.product.panels[i];
        if(panel.extraClassName.includes('cpb-custom-randomizer-ignore')) continue;
        if(panel.extraClassName.includes('cpb-custom-randomizer-one-category-in-tab')) {
          const category = panel.categories[Math.floor(Math.random() * panel.categories.length)];
          panel = JSON.parse(JSON.stringify(panel));
          panel.categories = [category];
        }
        for(let j = 0; j < panel.categories.length; j++) {
          const category = panel.categories[j];
          if(category.extraClassName.includes('cpb-custom-randomizer-ignore')) continue;
          if(category.type === 'input') continue;
          if(category.type === 'inputLong') continue;
          if(category.type === 'fileUpload') continue;          
          const optionsInStock = category.options.filter(option => option.inStock);
          const option = optionsInStock[Math.floor(Math.random() * optionsInStock.length)];
          setTimeout(function() {FrontendApi.updateOptions({panel, category, options: [option]}); console.log('cat: ', category)}, timeout);
          timeout += 1000;
        }
      }
  	}
  }
  
  const saveBuild = {
    lastAction: false,
    cart: false,
    modal: false,
    async init() {
      const that = this;
      if(CPB.getStore().getState().hasRedirectToCart) return console.warn('To activate save build please turn off the redirect to cart.');
      this.addButton();
      this.addOpenSavedBuildsButton();
      this.modal = alertify.dialog('myAlert',function factory(){
        return {
          setup: function(){
              return { 
                buttons:[{text: "Close", key:27/*Esc*/}]
              };
          },
          prepare: function(){
            let content = '<div class="cpb-custom-builds-contaner">';
			let builds = localStorage.getItem('cpb-custom-saved-builds');
            builds = builds ? JSON.parse(builds) : [];
            builds.forEach(build => {
              content += '<div class="cpb-custom-build" data-link="' + build.link + '">';
              content += '<button class="cpb-custom-build__delete">Delete</button>';
              content += '<a class="cpb-custom-build__load" href="' + build.link + '">Load</a>';
              content += '<img class="cpb-custom-build__image" src="' + build.image + '"/>';
              content += '</div>';              
            });
            content += '</div>';
            this.setContent(content);
            this.setHeader('Saved builds');
            this.setting('modal', false);
            this.setting('closableByDimmer', false);
            this.setting('movable', false);
            this.setting('resizable', false);
          }
        }
      });
      $(document).on('click', '.cpb-custom-build__delete', function() {
		that.removeBuild($(this).parent().attr('data-link'));
        $(this).parent().remove();
      });
      document.addEventListener('cpb-add-to-cart', this.addToCartProcess.bind(this));
    },
    addOpenSavedBuildsButton() {
      const getInspiredLink = window.cpbCustomGetInspiredLink || 'https://www.sjcdrums.com/collections/wicked-custom-snare-drums';
      const button = $('<button class="cpb-actions-btn cpb-custom-open-saved-builds">').html('<span>See my saved builds</span>');
      const button2 = $('<a class="cpb-actions-btn cpb-custom-open-all-builds" href="' + getInspiredLink + '">')
      .html('<span>Get inspired</span>');
//       const wrapper = $('<div class="cpb-custom-additional-action-buttons">').append(button, button2);
      button.on('click', this.openModal);
      $('.cpb-add-to-cart-button').before(button).before(button2);
    },
    addButton() {
      const that = this;
      const btn = $('<button class="cpb-actions-btn cpb-custom-actions-btn cpb-custom-save-build">').append($('<span>').text('Save build'));
      const addToCart = $('.cpb-add-to-cart-button');
      btn.on('click', function() {
        that.writeCart();
        addToCart.trigger('click');
        that.lastAction = 'save';
      });
      addToCart.on('click', function() {
      	that.lastAction = 'add';
      });
      addToCart.after(btn);
    },
    addToCartProcess() {
      // if(this.lastAction === 'add') location.href = '/cart';
      if(this.lastAction === 'save') {
      	this.removeAddedProduct();
        this.saveBuildToStarage();
      }
    },
    async saveBuildToStarage() {
      let builds = localStorage.getItem('cpb-custom-saved-builds');
      builds = builds ? JSON.parse(builds) : [];
      const currentBuild = {
        link: location.origin + location.pathname + '?configid=' + window._cpb.saveConfig(null, false),
        image: window.cpbImageStorage.views.front.getSnapshot()
      }
      builds.push(currentBuild);
      localStorage.setItem('cpb-custom-saved-builds', JSON.stringify(builds));
    },
    removeBuild(link) {
      let builds = localStorage.getItem('cpb-custom-saved-builds');
      builds = builds ? JSON.parse(builds) : [];
      const buildToRemove = builds.find(build => build.link === link);
      if(!buildToRemove) return;
      builds.splice(builds.indexOf(buildToRemove), 1);
      localStorage.setItem('cpb-custom-saved-builds', JSON.stringify(builds));
    },
    async getCart() {
      const response = await fetch('/cart.js');
      return await response.json();
    },
    async writeCart() {
      this.cart = await this.getCart();
    },
    async removeAddedProduct() {
      const newCart = await this.getCart();
      let variants = {};
      this.cart.items.forEach(item => {variants[+item.variant_id] = variants[+item.variant_id] ? variants[+item.variant_id] + +item.quantity : +item.quantity});
      newCart.items.forEach(item => {if(!variants[+item.variant_id]) variants[+item.variant_id] = 0});
      fetch('/cart/update.js', {method: 'POST', body: JSON.stringify({updates: variants}), headers: {'Content-Type': 'application/json'}});
    },
    openModal() {
      alertify.myAlert().show();
    }
  }
  
  async function activateFrontendAPI() {
  	const getFrontendApi = await CPB.FrontendApi();
	return new getFrontendApi();
  }
  
  function addSocialSharebuttons() {
  	const socialShare = $('#cpb-custom-social-share');
    const actionsRow = $('.cpb-product-actions-container').closest('.row');
    actionsRow.after($('<div class="row cpb-custom-row">').append(socialShare.css('display', '')));
    
    const buttons = socialShare.find('a');
    buttons.on('click', function(e) {
      const btn = $(this);
      e.preventDefault();
      const url = btn.attr('href') + location.origin + location.pathname + '?configid=' + window._cpb.saveConfig(null, false);
      window.open(url,'_blank');
    });
  }	
})(jQuery);